import React, { useState } from "react";
import useStorageState from "@/hooks/useStorageState";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { IVRMSupplierDetail, IVRMSupplierSearchFields, supplierService } from "./supplierService";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile"
import { convertRes2Blob } from "@/utils/exportFile";
import moment, { Moment } from "moment";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "../dict/dictModel";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums"
import { transPgToPagination } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const useSupplierModel = createModel(function () {
    const { user, setsupplieAllList, setLocale } = useGlobalModel();
    const { getTreeNodeName } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IVRMSupplierDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IVRMSupplierSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //所有列表查询
    const loadSupplierAllData = async () => {
        const params = {
            pageSize: 10000,
            pageNum: 1
        }
        let { retData } = await supplierService.page(params);
        const { records, ...pg } = retData;
        setsupplieAllList(records)
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IVRMSupplierSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        console.log(searchParams)
        let { retData } = await supplierService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IVRMSupplierSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    /** 
     * 表单详情
     */

    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<IVRMSupplierDetail>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<IVRMSupplierDetail>({ enable: 1, createUser: user.username });
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal({});
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({});
    }
    //获取一条详情数据 Api
    const getSupplierOne = async (id: string) => {
        let { retData } = await supplierService.one(id);
        retData && setEditFormVal(retData);
    }

    //表单新增 Api
    const insertSupplier = async (data: IVRMSupplierDetail) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            enable: data.enable ? 1 : 0,
            createUser: user.username,
            typeName: getTreeNodeName(data.typeCode as string)
        }
        let { retData } = await supplierService.insert(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "供应商新增成功", type: "success" })
            // : globalPrompt("message", { text: "供应商新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["The supplier is added successfully."], type: "success" })
            : globalPrompt("message", { text: Locale["The supplier is added unsuccessfully."], type: "error" });
        return retData;
    }

    //表单编辑 Api
    const editSupplier = async (data: IVRMSupplierDetail) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            enable: data.enable ? 1 : 0,
            updateUser: user.username,
            typeName: getTreeNodeName(data.typeCode as string)
        }
        let { retData } = await supplierService.update(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "供应商编辑成功", type: "success" })
            // : globalPrompt("message", { text: "供应商编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["The supplier is edited successfully."], type: "success" })
            : globalPrompt("message", { text: Locale["The supplier is edited unsuccessfully."], type: "error" });
        return retData;
    }
    //供应商状态开启禁用
    const onDisabled = async (id: string, checked: boolean) => {
        let { retData } = await supplierService.disable({ id, enable: checked ? 1 : 0 })
        retData ?
            // loadData() && globalPrompt("message", { text: "供应商编辑成功", type: "success" })
            // : globalPrompt("message", { text: "供应商编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["The supplier is edited successfully."], type: "success" })
            : globalPrompt("message", { text: Locale["The supplier is edited unsuccessfully."], type: "error" });
        return retData;
    }
    //导入
    const importSupplier = async (file: { file: File }) => {
        let { retData } = await supplierService.import(file);
        retData ?
            // loadData() && globalPrompt("message", { text: "导入成功", type: "success" })
            // : globalPrompt("message", { text: "导入失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully imported"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully imported"], type: "error" });
        return retData;
    }

    //导出
    const exportSupplier = async (searchValue: IVRMSupplierSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let result = await supplierService.export(searchParams);
        // result.retData ?
        //     globalPrompt("message", { text: "导出成功", type: "success" })
        //     : globalPrompt("message", { text: "导出失败", type: "error" });
        // return result.retData;
        convertRes2Blob(result)
    }

    //供应商转客户
    const transferSupplier = async (id: string) => {
        let { retData } = await supplierService.transfer(id);
        retData ?
            loadData() && globalPrompt("message", { text: "供应商转客户成功", type: "success" })
            : globalPrompt("message", { text: "供应商转客户失败", type: "error" });
        return retData;
    }

    //下载模板
    const downloadTpl = async (id: string) => {
        let result = await supplierService.downloadTpl();
        convertRes2Blob(result)
        // retData ?
        //     globalPrompt("message", { text: "下载模板成功", type: "success" })
        //     : globalPrompt("message", { text: "下载模板失败", type: "error" });
        // return retData;
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        editFormVal,
        addFormVal,
        /***method***/
        updateAddFormVal,
        updateEditFormVal,
        insertSupplier,
        editSupplier,
        getSupplierOne,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        importSupplier,
        exportSupplier,
        transferSupplier,
        downloadTpl,
        setEditFormVal,
        setAddFormVal,
        onDisabled,
        loadSupplierAllData
    }
});